<template>
  <div>
    <div v-if="finished">
      <div class="d-flex justify-center mt-5">
        <p>{{ $t('order_finished') }}</p>
      </div>
    </div>

    <div v-if="!isCartReady && !finished">
      <div class="d-flex justify-center mt-5">
        <p>{{ $t('cart_is_empty') }}</p>
      </div>
    </div>

    <div v-if="isCartReady && !finished">
      <ol class="cart-items-list">
        <li
          v-for="(item, index) in cart.items"
          :key="'car-item-' + index"
        >
          <div>
            <a :href="'/detail/' + item.productVariant.product.id">
              <img
                :src="coverImage(item)"
                :alt="item.name"
              >
            </a>
            <div>
              <a :href="'/detail/' + item.productVariant.product.id">{{ item.name }}</a>
              <span>
                <br>
                <small class="text-block">
                  {{ item.note }}
                </small>
              </span>
            </div>
          </div>
          <div>
            <div>
              <strong>{{ formatPrice(item.priceWithTax) }} Kč</strong>
              <v-btn
                variant="plain"
                icon="mdi-close"
                @click="removeItem(item.productVariant.id)"
              />
            </div>
          </div>
        </li>
      </ol>
      <v-form
        class="order-details"
        @submit.prevent="submitOrder"
      >
        <h2>{{ $t('personal_data') }}</h2>

        <v-text-field
          v-model="fullName"
          :error-messages="getViolation('fullName')"
          :label="$t('full_name')"
          variant="outlined"
        />

        <v-text-field
          v-model="email"
          :error-messages="getViolation('email')"
          :label="$t('email')"
          variant="outlined"
        />

        <v-text-field
          v-model="phone"
          :error-messages="getViolation('phone')"
          :label="$t('phone')"
          variant="outlined"
        />

        <v-textarea
          v-model="note"
          :error-messages="getViolation('note')"
          :label="$t('note')"
          variant="outlined"
        />

        <div class="terms-checkbox">
          <v-checkbox
            v-model="terms"
            :true-value="true"
            :false-value="false"
          >
            <template #label>
              <!-- terms and conditions for RAW HTML -->
              <span v-html="$t('agree_with_terms')" />
            </template>
          </v-checkbox>
        </div>

        <p>{{ $t('before_order_message') }}</p>

        <div class="d-flex justify-center mt-5">
          <v-btn
            :disabled="submitDisabled"
            type="submit"
            :loading="loading"
            size="large"
            variant="flat"
            color="#000"
          >
            {{ $t('send_order') }}
          </v-btn>
        </div>
      </v-form>
    </div>
  </div>
</template>

<script>
import Axios from '../ajax'
import { useShoppingCartStore } from '../stores/shoppingCartStore'
import { errorMixin } from '../mixins/error-mixin'
import Qs from 'qs'

export default {
  name: 'VFormShoppingCart',
  mixins: [
    errorMixin
  ],
  data () {
    return {
      finished: false,
      fullName: null,
      email: null,
      phone: null,
      note: null,
      loading: false,
      terms: false
    }
  },
  computed: {
    submitDisabled () {
      return this.terms === false
    },
    isCartReady () {
      if (this.cart) {
        if (this.cart?.items) {
          if (this.cart?.items.length > 0) {
            return true
          }
        }
      }
      return false
    },
    cart: {
      get () {
        const store = useShoppingCartStore()
        return store.getShoppingCart
      },
      set (val) {
        const store = useShoppingCartStore()
        store.setShoppingCart(val)
      }
    }
  },
  created () {
    this.fetchShoppingCart()
  },
  methods: {
    async submitOrder () {
      this.loading = true
      try {
        await Axios.post('/order.json', Qs.stringify({
          fullName: this.fullName,
          email: this.email,
          phone: this.phone,
          note: this.note
        }))

        this.fullName = null
        this.email = null
        this.phone = null
        this.note = null
        this.finished = true
      } catch (e) {
        this.buildViolations(e.response)
      }
      this.loading = false
    },
    coverImage (item) {
      return item.cover.replace('/media/', '/media/cache/square/')
    },
    async fetchShoppingCart () {
      const response = await Axios.get('/kosik.json')
      this.cart = response.data
    },
    formatPrice (price) {
      const basePrice = price / 100
      return new Intl.NumberFormat('cs-CZ', {
        style: 'decimal',
        maximumFractionDigits: 2
      }).format(basePrice)
    },
    async removeItem (id) {
      await Axios.post('/kosik.json', Qs.stringify({
        product: id,
        quantity: 0
      }))
      await this.fetchShoppingCart()
    }
  }
}
</script>
